<fn-modal-header class="modal-header">
  <h5 class="modal-title" mat-dialog-title>Alert Disable</h5>
  <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
    <span aria-hidden="true">&times;</span>
  </button>
</fn-modal-header>
<mat-dialog-content>
  <div class="row">
      <div class="col-6">
              <label for="Database">Database</label>
              <fn-base-input placeholder="Enter Database" [(ngModel)]="objectHash.database"
                  [ngModelOptions]="{standalone: true}"></fn-base-input>

      </div>       
      <div class="col-6">
      <label for="Schema">Schema</label>
              <fn-base-input placeholder="Enter Schema" [(ngModel)]="objectHash.schema"
                  [ngModelOptions]="{standalone: true}"></fn-base-input>
      </div>
  </div>
  <div class="row ">
    <div class="col-6">
      <label for="Server">Server</label>
      <fn-base-input placeholder="Enter Server" [(ngModel)]="objectHash.server"
        [ngModelOptions]="{ standalone: true }"></fn-base-input>
    </div>
    <div class="col-6">
      <label for="AppInstance">App Instance</label>
      <fn-base-input placeholder="Enter App Instance" [(ngModel)]="objectHash.appInstance"
        [ngModelOptions]="{ standalone: true }"></fn-base-input>
    </div>
  </div>
  <div class="row ">
    <div class="col-6">
      <label for="DirPath">Dir Path</label>
      <fn-base-input placeholder="Enter Dir Path" [(ngModel)]="objectHash.dirPath"
        [ngModelOptions]="{ standalone: true }"></fn-base-input>
    </div>
  </div>
  <div class="row ">
    <div class="col-6">
      <label for="EndDate">Set End Date and Time</label>
      <fn-date-picker [selectedDate]="endDate" (callback)="changeDate1($event)"
        (nextDisabledCallback)="nextDisable1($event)" 
        (prevDisabledCallback)="prevDisable1($event)">
      </fn-date-picker>
    </div>
 
    <div class="col-6">
      <label for="StartDate">Set Start Date and Time</label>
      <fn-date-picker [selectedDate]="startDate" (callback)="changeDate($event)"
        (nextDisabledCallback)="nextDisable($event)" 
        (prevDisabledCallback)="prevDisable($event)">
      </fn-date-picker>
    </div>
  </div>
  <div class="row ">
    <div class="col-6">
      <label for="isActive">isActive</label>
      <fn-switch [(ngModel)]="objectHash.isActive" [name]="'isActive'"></fn-switch>
    </div>
    <div class="col-6">
      <label for="isGlobal">isGlobal</label>
      <fn-switch [(ngModel)]="objectHash.isGlobal" [name]="'isGlobal'"></fn-switch>
    </div>
  </div>
  <div class="row ">
    <div class="col-6">
      <label for="Where Clause">Where clause</label>
      <fn-base-input placeholder="Enter Where Clause" [(ngModel)]="objectHash.whereClause"
        [ngModelOptions]="{ standalone: true }"></fn-base-input>
    </div>
    <!-- <div class="col-6">
      <label for="Where Clause">Disabled By</label>
      <fn-base-input placeholder="disabledBy" [(ngModel)]="objectHash.disabledBy"
        [ngModelOptions]="{ standalone: true }"></fn-base-input>
    </div> -->
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="row">
    <div class="col-6 text-left">
      <button class="btn btn-danger float-left btn-round" (click)="close()">
        Cancel
      </button>
    </div>
    <div class="col-6 text-right">
      <button class="btn btn-primary float-right btn-round" (click)="add()">
        Add
      </button>
    </div>
  </div>
</mat-dialog-actions>
